import { createEnv } from '@t3-oss/env-core';
import { clientSchema } from './schema';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: clientSchema,
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
